import { render, staticRenderFns } from "./EmpresaBlocoInserirContratoManualmenteAlvorada.vue?vue&type=template&id=4668c48d&lang=pug"
import script from "./EmpresaBlocoInserirContratoManualmenteAlvorada.vue?vue&type=script&lang=js"
export * from "./EmpresaBlocoInserirContratoManualmenteAlvorada.vue?vue&type=script&lang=js"
import style0 from "./EmpresaBlocoInserirContratoManualmenteAlvorada.vue?vue&type=style&index=0&id=4668c48d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports